export default {
  namespaced: true,
  state: () => ({
    cores: [],
    filters: {
      q: null,
      page: 1,
      perPage: 10,
      sortBy: null,
      sortDesc: null,
    },
  }),
  mutations: {
    setCores(state, cores) {
      state.cores = cores;
    },
    setFilters(state, payload) {
      state.filters = payload;
    },
    setPage(state, payload) {
      state.filters.page = payload;
    },
  },
  getters: {
    getCores(state) {
      return state.cores;
    },
    getFilters(state) {
      return state.filters;
    },
  },
};
